<template>
  <div>
    <div class="left-alert-container" v-if="visible" ref="containerRef">
      <img
        :src="currentStatusImage"
        alt="警讯状态"
        class="left-alert-btn"
        @click="toggleOpen"
      />

      <div class="left-alert-content" v-if="isOpen">
        <template v-if="fetchFromApi">
          <div class="left-alert-toolbar">
            <!-- @keyup.enter="applyKeywordSearch"
            @click:clear="applyKeywordSearch" -->
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <v-text-field
                v-model="filterKeyword"
                class="left-alert-field left-alert-search"
                placeholder="搜项目名称"
                persistent-placeholder
                prepend-inner-icon="mdi-magnify"
                variant="outlined"
                density="compact"
                hide-details
                clearable
                style="margin-right: 10px;"
              />
              <v-select
                v-model="filterChangeType"
                class="left-alert-field"
                :items="changeTypeSelectItems"
                item-title="title"
                item-value="value"
                label="类型"
                variant="outlined"
                density="compact"
                hide-details
                style="width: 30px;"
              />
            </div>
            <div class="left-alert-date-row">
              <div class="native-date-wrapper">
                <v-text-field
                  :model-value="formatDateShow(filterDateFrom)"
                  placeholder="开始日期"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  class="left-alert-field native-date-field"
                  @click="openDateFromPicker"
                />
                <input
                  ref="dateFromInputRef"
                  type="date"
                  v-model="filterDateFrom"
                  :max="filterDateTo || undefined"
                  style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                  @change="onDateFromChange"
                />
              </div>
              <span class="left-alert-date-sep">至</span>
              <div class="native-date-wrapper">
                <v-text-field
                  :model-value="formatDateShow(filterDateTo)"
                  placeholder="结束日期"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  class="left-alert-field native-date-field"
                  @click="openDateToPicker"
                />
                <input
                  ref="dateToInputRef"
                  type="date"
                  v-model="filterDateTo"
                  :min="filterDateFrom || undefined"
                  style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                  @change="onDateToChange"
                />
              </div>
              <v-btn color="primary" variant="flat" style="min-width: 46px;width: 46px" @click="handleSearchClick">查询</v-btn>
            </div>
            <!-- <div class="left-alert-date-actions">
              <button type="button" class="left-alert-link-btn" @click="clearDateRange">
                全部时间
              </button>
            </div> -->
          </div>
          <!-- || filterChangeType  -->
          <div v-show="initialListLoaded && !listLoading && hasSearched" class="left-alert-count-summary">
            <div
              v-for="card in countCards"
              :key="card.changeType"
              class="left-alert-count-box"
              :class="{ 'left-alert-count-box--muted': isCountCardMuted(card) }"
            >
              <div class="left-alert-count-top">
                <span class="left-alert-count-title">{{ card.title }}</span>
                <span class="left-alert-count-label">次数</span>
              </div>
              <div class="left-alert-count-bottom">
                <span v-if="!isCountCardMuted(card)" class="left-alert-count-num">{{
                  card.count
                }}</span>
                <span v-else class="left-alert-count-num left-alert-count-num--muted">/</span>
              </div>
            </div>
          </div>
        </template>

        <div
          ref="scrollRef"
          class="left-alert-scroll"
          @scroll.passive="onScroll"
        >
          <template v-if="displayItems.length > 0">
            <div
              v-for="(item, index) in displayItems"
              :key="item.id ?? index"
              class="alert-card"
            >
            <div class="top">
              <div class="top-border" />
              <div class="top-content">
                <div class="top-left">
                  <div class="time">{{ formatNoticeTime(item.createTime ?? item.time) || '/' }}</div>
                  <div class="d-flex align-center justify-space-between">
                    <div class="card-title">{{ item.contractName || '/' }}</div>
                    <img class="change-type-tag" v-if="item.changeType === 'QTY_UPDATE'" :src="numChangeImg" alt="数量变更" />
                    <img class="change-type-tag" v-if="item.changeType === 'DRAW_UPDATE'" :src="drawChangeImg" alt="图纸变更" />
                  </div>
                  <div class="order-no">{{ item.contractCode || '/' }}</div>
                  <!-- <div class="time" v-if="searchType !== 'mine'">接收人：{{ item.notificationRecipients || '/' }}</div> -->
                  <div class="time">预计交期：{{ formatDate(item.deliveryTime) }}</div>
                </div>
              </div>

            </div>

            <div class="goods">
               <!-- v-if="!item.multipleAggregated" -->
              <div class="cover-wrap">
                <img
                  v-if="item.imageUrls && typeof item.imageUrls === 'string' && JSON.parse(item.imageUrls).length > 0 && JSON.parse(item.imageUrls)[0].url"
                  class="cover-img"
                  :src="item.imageUrls && typeof item.imageUrls === 'string' && JSON.parse(item.imageUrls).length > 0 ? JSON.parse(item.imageUrls)[0].url : ''"
                  alt=""
                />
                <img v-else class="cover-placeholder" src="@/assets/noImg.jpg"/>
                <img v-if="item.typeOf === '一厂'" src="@/assets/allotOne.png" class="factory" />
                <img v-if="item.typeOf === '二厂'" src="@/assets/allotTwo.png" class="factory" />
                <img v-if="item.typeOf === '三厂'" src="@/assets/allotThree.png" class="factory" />
                <img v-if="item.typeOf === '四厂'" src="@/assets/allotFour.png" class="factory" />
                <div v-if="item.productName" class="job">
                  {{ item.productName }}
                </div>
              </div>
              <div class="meta">
                <div class="meta-row">
                  <span class="meta-label">编号</span>
                  <span class="meta-value">{{ item.productCode ?? '/' }}</span>
                </div>
                <div class="meta-row">
                  <span class="meta-label">批号</span>
                  <span class="meta-value" v-if="!item.multipleAggregated">{{ item.batch ?? '/' }}</span>
                  <span class="meta-value" v-else>
                    <v-tooltip location="top" :open-delay="200">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/inputTip.png"
                          alt="批号"
                          style="width: 15px; height: 15px; cursor: pointer; vertical-align: middle;"
                        />
                        {{ item.aggregatedBatches.length }}
                      </template>
                      <div class="batch-tooltip">
                        <!-- <div class="batch-tt-header">
                          <span>批号</span>
                          <span>交期</span>
                        </div> -->
                        <!-- <div class="batch-tt-row" v-for="(b, bi) in item.aggregatedBatches" :key="bi">
                          <span>{{ b.batch || '/' }}</span>
                          <span>{{ b.deliveryTime ? formatDate(b.deliveryTime) : '/' }}</span>
                        </div> -->
                        <div class="batch-tt-row">
                          <span class="batch-comma-list">{{ item.aggregatedBatches.map(b => b.batch || '/').join('，') }}</span>
                        </div>
                      </div>
                    </v-tooltip>
                  </span>
                </div>
                <div class="meta-row">
                  <span class="meta-label">尺寸</span>
                  <span class="meta-value">{{ item.productSize ?? '/' }}</span>
                </div>
              </div>
              <div class="actions-btns" v-if="searchType === 'panel'">
                <div class="d-flex">
                  <div class="action-btn" v-if="item.changeType === 'QTY_UPDATE'" @click="handleExportChangeOrder(item)">导出变更单</div>
                  <div class="action-btn" v-if="item.changeType === 'DRAW_UPDATE'" @click="handleExportNewDraw(item)">导出变更单</div>
                  <div class="log-btn" @click="handleViewExportRecord(item)" v-if="item.isShowLog">
                    <img src="@/assets/logBtn.png" alt="" style="width: 20px;">
                  </div>
                </div>
                <div style="color:#66BB6A;font-size: 12px;text-align:center" v-if="item.operationTime">上次导出 {{ formatIntDate(item.operationTime) }}</div>
                <!-- <div class="action-btn" v-if="item.changeType === 'DRAW_UPDATE'" @click="handleViewNewDraw(item)">原图纸</div> -->
              </div>
            </div>

            <div v-if="item.changeType === 'QTY_UPDATE'">
              <div class="change-info">
                <div>总数</div>
                <div class="count">
                  <div class="count-val">{{ item.oldCount }}</div>
                  <img src="@/assets/right.png" class="count-arrow" />
                  <div class="count-val">{{ item.newCount }}</div>
                </div>
              </div>
              <!-- <div class="change-head">
                <span>区域</span>
                <span>数量</span>
              </div>

              <template v-if="item.areaList?.length">
                <div
                  v-for="row in item.areaList"
                  :key="`${row.building}-${row.floor}-${row.areaRoomType}-${row.roomNumber}`"
                  class="change-row"
                >
                  <span class="area-name">
                    <template v-if="row.building">{{ row.building }}</template>
                    <template v-if="row.building && row.floor">/</template>
                    <template v-if="row.floor">{{ row.floor }}</template>
                    <template v-if="row.floor && row.areaRoomType">/</template>
                    <template v-if="row.areaRoomType">{{ row.areaRoomType }}</template>
                    <template v-if="row.areaRoomType && row.roomNumber">/</template>
                    <template v-if="row.roomNumber">{{ row.roomNumber }}</template>
                  </span>
                  <div class="count">
                    <span class="count-val">{{ row.quantity }}</span>
                    <img src="@/assets/right.png" class="count-arrow" />
                    <span class="count-val">{{ row.newQuantity }}</span>
                  </div>
                </div>
              </template>
              <div v-else class="change-empty">暂无区域数量变更</div> -->
              </div>
              <!-- searchType === 'mine' &&  -->
              <template v-if="item.changeType === 'DRAW_UPDATE'">
                <!-- 变更信息 -->
                <div class="change-detail-panel" v-if="item.changeReasonType">
                  <div class="change-detail-row">
                    <span class="change-detail-label">申请人</span>
                    <span class="change-detail-value">{{ item.initiatorName || '/' }}</span>
                  </div>
                  <div class="change-detail-row" v-if="item.changeReasonType">
                    <text class="change-detail-label">变更类型</text>
                    <div class="change-detail-value reason">
                      <template v-for="(sub,subIndex) in item.changeReasonType">
                        <div>{{ sub }}</div>
                      </template>
                    </div>
                  </div>
                  <div class="change-detail-row" v-if="item.changeReason">
                    <span class="change-detail-label">变更原因</span>
                    <span class="change-detail-value reason">{{ item.changeReason || '/' }}</span>
                  </div>
                  <div class="change-detail-row" v-if="item.changeDetail">
                    <span class="change-detail-label">变更内容</span>
                    <span class="change-detail-value">{{ item.changeDetail || '/' }}</span>
                  </div>
                </div>

                <!-- 统计 -->
                <!-- <div class="stats" v-if="item.laborLoss !== null || item.laborLoss != '' || item.materialLoss !== null || item.materialLoss != ''"> -->
                <div class="stats" v-if="(Number(item.lossStatus) === 1 || Number(item.lossStatus) === 2) && (item.laborLoss != null || item.materialLoss != null)">
                  <div class="stat-item">
                    <div class="stat-label">工时损耗</div>
                    <div class="stat-value">{{ item.laborLoss  }}元</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-label">材料损耗</div>
                    <div class="stat-value">{{ item.materialLoss }}元</div>
                  </div>
                </div>

                <!-- 工序统计 -->
                <div class="process-stats" v-if="item.workReportList && item.workReportList.length">
                  <div class="process-header">
                    <span class="ph-cell">工序</span>
                    <span class="ph-cell">已报工时</span>
                    <span class="ph-cell">已报件数</span>
                  </div>
                  <div class="process-row" v-for="(process, idx) in item.workReportList" :key="idx">
                    <div class="p-cell tag-cell">
                      <span v-if="process.processName === '设计'" class="process-design-tag">设计</span>
                      <!-- <span v-else class="process-name-tag">{{ process.processName }}</span> -->
                      <img v-else :src="getProcessImage(process.processName)" style="height: 22px;"/>
                    </div>
                    <span class="p-cell">{{ process.processTime || '/' }}</span>
                    <span class="p-cell">
                      <template v-if="process.processName === '设计'">/</template>
                      <template v-else>{{ process.processCount || '/' }}</template>
                    </span>
                  </div>
                </div>

                <!-- 操作按钮 -->
                <!-- <div class="card-actions" v-if="Number(item.auditStatus) === 0">
                  <div class="action-btn btn-reject" @click="handleReject(item)">驳回</div>
                  <div class="action-btn btn-approve" @click="handleApprove(item)">审核</div>
                </div> -->

                <!-- 状态标签 -->
                <div class="status-bar" v-if="searchType === 'mine'">
                  <div class="status-tag status-wait" v-if="Number(item.auditStatus) === 0">审核中</div>
                  <div class="status-tag status-approved" v-if="Number(item.auditStatus) === 1">已审核</div>
                  <div class="status-tag status-rejected" v-if="Number(item.auditStatus) === 2">已驳回</div>
                </div>
              </template>
            </div>
          </template>

          <template v-else-if="messages.length > 0">
            <div class="legacy-list">
              <div
                v-for="(msg, index) in messages"
                :key="index"
                class="legacy-item"
              >
                {{ msg }}
              </div>
            </div>
          </template>

          <div
            v-else-if="fetchFromApi && listLoading"
            class="left-alert-empty"
          >
            加载中…
          </div>
          <div v-else-if="listError" class="left-alert-empty">{{ listError }}</div>
          <div v-else class="left-alert-empty">暂无警讯消息</div>

          <div v-if="fetchFromApi && displayItems.length > 0" class="list-footer">
            <span v-if="listLoadingMore" class="footer-text">加载中…</span>
            <span v-else-if="!hasMore" class="footer-text muted">没有更多了</span>
          </div>
        </div>
        <v-btn
          v-if="fetchFromApi && showBatchExportButton && searchType === 'panel'"
          color="primary"
          variant="flat"
          class="left-alert-batch-export"
          :disabled="!canBatchExport || exportingBatch || exportingChangeOrder || exportingNewDraw"
          :loading="exportingBatch"
          @click="exportAllItems"
        >
          批量导出
        </v-btn>
        <div class="search-type-toggle">
          <v-btn-toggle v-model="searchType" mandatory class="button-group">
            <v-btn value="panel" class="toggle-button" variant="text">警讯</v-btn>
            <v-btn value="mine" class="toggle-button" variant="text">我的</v-btn>
          </v-btn-toggle>
        </div>
      </div>
    </div>
    <div class="change-order-export-host" aria-hidden="true">
      <ChangeOrderPdfPreviewDialog
        :item="currentChangeOrderItem"
        :format-notice-time="formatNoticeTime"
      />
    </div>
    <div class="draw-change-cover-host" aria-hidden="true">
      <DrawChangeCoverPdfPreview
        :item="currentDrawCoverItem"
        :format-notice-time="formatNoticeTime"
      />
    </div>
    <div
      v-if="exportingChangeOrder || exportingNewDraw || exportingBatch"
      class="common-loading-overlay"
    >
      <div class="common-loading-container">
        <div class="common-loading-spinner" />
        <p class="common-loading-text">
          {{
            exportingBatch
              ? '正在批量导出变更单...'
              : exportingNewDraw
                ? '正在导出新图纸...'
                : '正在导出变更单...'
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
/** 与 jf-client alertCard 一致的数量变更行 */
export interface LeftAlertChangeRow {
  name: string
  before: string | number
  after: string | number
}

/** 单条警讯卡片数据 */
export interface LeftAlertCardItem {
  id?: string | number
  createTime?: string | number
  time?: string
  title?: string
  orderNo?: string
  cover?: string
  /** 左下角覆盖文案，如「椅子」（优先于 typeOf） */
  category?: string
  /** 与小程序一致：显示为「{typeOf}厂」 */
  typeOf?: string
  code?: string
  batch?: string
  size?: string
  changes?: LeftAlertChangeRow[]
  /** 右上角标签，默认「数量变更」 */
  tag?: string
  /** 接口若返回已读状态，用于未读角标统计 */
  read?: boolean
}
</script>

<script setup lang="ts">
import { computed, nextTick, onBeforeUnmount, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import closeStatusReadImg from '@/assets/closeStatus_read.png'
import closeStatusUnreadImg from '@/assets/closeStatus_unread.png'
import openStatusImg from '@/assets/openStatus.png'
import { urgentNoticeApi } from '@/services/api'
import ChangeOrderPdfPreviewDialog from '@/components/ChangeOrderPdfPreviewDialog.vue'
import DrawChangeCoverPdfPreview from '@/components/DrawChangeCoverPdfPreview.vue'
import { useSnackbar } from '@/composables/useSnackbar'
import numChangeImg from '@/assets/num_change.png'
import drawChangeImg from '@/assets/draw_change.png'
import { processStatusOptions } from '@/constants/contract'

interface Props {
  visible?: boolean
  title?: string
  /** 为 false 时沿用外部传入的 items / unreadCount */
  fetchFromApi?: boolean
  /** 列表分页条数 */
  pageSize?: number
  items?: LeftAlertCardItem[]
  messages?: string[]
  unreadCount?: number
}

const props = withDefaults(defineProps<Props>(), {
  visible: true,
  title: '警讯消息',
  fetchFromApi: true,
  pageSize: 10,
  items: () => [],
  messages: () => []
})

const emit = defineEmits<{
  (e: 'toggle', open: boolean): void
  (e: 'open'): void
  (e: 'close'): void
  (e: 'refresh-unread'): void
}>()

const isOpen = ref(false)
const scrollRef = ref<HTMLElement | null>(null)
const containerRef = ref<HTMLElement | null>(null)

const internalItems = ref<LeftAlertCardItem[]>([])
const internalUnreadCount = ref(0)
const listPage = ref(1)
const listLoading = ref(false)
const listLoadingMore = ref(false)
const listError = ref('')
const hasMore = ref(true)
const exportingChangeOrder = ref(false)
const exportingNewDraw = ref(false)
/** 顺序执行多条导出，避免与单条点击并发 */
const exportingBatch = ref(false)
const currentChangeOrderItem = ref<Record<string, unknown>>({})
const currentChangeOrderOriginalItem = ref<Record<string, unknown> | null>(null)
/** 导出新图纸时，封面页（图纸变更）与变更单同结构 */
const currentDrawCoverItem = ref<Record<string, unknown>>({})
const { showSuccess, showError } = useSnackbar()
const router = useRouter()

const PDF_QUALITY = 1

/** 与 jf-client panel 一致的变更类型筛选 */
const changeTypeSelectItems: { title: string; value: string | null }[] = [
  { title: '全部类型', value: null },
  { title: '数量变更', value: 'QTY_UPDATE' },
  { title: '图纸变更', value: 'DRAW_UPDATE' }
]

const filterKeyword = ref('')
const filterChangeType = ref<string | null>(null)
const filterDateFrom = ref('')
const filterDateTo = ref('')
const hasSearched = ref(false)
const dateFromInputRef = ref<HTMLInputElement | null>(null)
const dateToInputRef = ref<HTMLInputElement | null>(null)

/** 搜索类型：panel=警讯, mine=我的 */
const searchType = ref<'panel' | 'mine'>('panel')

const countItems = ref<Array<{ changeType?: string; count?: number | string }>>([])
const initialListLoaded = ref(false)

let keywordDebounceTimer: ReturnType<typeof setTimeout> | null = null

const countCards = computed(() => {
  const items = countItems.value || []
  const pick = (type: string) => {
    const it = items.find((x) => x.changeType === type)
    const n = it?.count
    return n == null || n === '' ? 0 : Number(n) || 0
  }
  return [
    { changeType: 'QTY_UPDATE', title: '数量变更', count: pick('QTY_UPDATE') },
    { changeType: 'DRAW_UPDATE', title: '图纸变更', count: pick('DRAW_UPDATE') }
  ]
})

function isCountCardMuted(card: { changeType: string }) {
  const t = filterChangeType.value
  return t != null && t !== '' && t !== card.changeType
}

function dayStartMs(iso: string): number {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d, 0, 0, 0, 0).getTime()
}

function dayEndMs(iso: string): number {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d, 23, 59, 59, 999).getTime()
}

/** 起止为同一天时，列表单次多取一些 */
function isSingleDayDateFilter(): boolean {
  const from = String(filterDateFrom.value || '').trim()
  const to = String(filterDateTo.value || '').trim()
  return !!from && !!to && from === to
}

function getNoticeListPageSize(): number {
  if (isSingleDayDateFilter()) {
    return 100
  }
  return props.pageSize
}

function buildNoticeListParams(targetPage: number): Record<string, unknown> {
  const body: Record<string, unknown> = {
    page: targetPage,
    pageNum: targetPage,
    pageSize: getNoticeListPageSize()
  }
  const kw = String(filterKeyword.value || '').trim()
  if (kw) body.keyword = kw
  if (filterDateFrom.value && filterDateTo.value) {
    body.startTime = dayStartMs(filterDateFrom.value)
    body.endTime = dayEndMs(filterDateTo.value)
  }
  if (filterChangeType.value) {
    body.changeType = filterChangeType.value
  }
  if (searchType.value === 'mine') {
    body.noticeFlag = 1
    body.myList = 1
  }
  return body
}

function openDateFromPicker() {
  const input = dateFromInputRef.value
  if (!input) return
  const original = input.style.pointerEvents
  input.style.pointerEvents = 'auto'
  input.focus()
  try {
    if (input.showPicker) {
      input.showPicker()
    } else {
      input.click()
    }
  } catch {
    input.click()
  }
  setTimeout(() => { input.style.pointerEvents = original }, 100)
}

function openDateToPicker() {
  const input = dateToInputRef.value
  if (!input) return
  const original = input.style.pointerEvents
  input.style.pointerEvents = 'auto'
  input.focus()
  try {
    if (input.showPicker) {
      input.showPicker()
    } else {
      input.click()
    }
  } catch {
    input.click()
  }
  setTimeout(() => { input.style.pointerEvents = original }, 100)
}

/** 日期筛选：仅当「都未选」或「起止都已选」时才拉列表；只选一侧不请求 */
function onDateFromChange(event: Event) {
  const target = event.target as HTMLInputElement
  target.blur()
  const newDate = target.value
  if (newDate && filterDateTo.value && newDate > filterDateTo.value) {
    showError('开始日期必须小于结束日期')
    filterDateFrom.value = ''
    target.value = ''
    return
  }
  filterDateFrom.value = newDate
  if(filterDateFrom.value === filterDateTo.value){
    hasSearched.value = false
  }
}

function onDateToChange(event: Event) {
  const target = event.target as HTMLInputElement
  target.blur()
  const newDate = target.value
  if (newDate && filterDateFrom.value && newDate < filterDateFrom.value) {
    showError('结束日期必须大于开始日期')
    filterDateTo.value = ''
    target.value = ''
    return
  }
  filterDateTo.value = newDate
  if(filterDateFrom.value === filterDateTo.value){
    hasSearched.value = false
  }
}

function onFilterChangeImmediate() {
  if (!props.fetchFromApi || !isOpen.value) return
  resetListState()
  void fetchNoticePage(true)
}

function scheduleKeywordFetch() {
  if (keywordDebounceTimer) clearTimeout(keywordDebounceTimer)
  keywordDebounceTimer = setTimeout(() => {
    keywordDebounceTimer = null
    if (!props.fetchFromApi || !isOpen.value) return
    resetListState()
    void fetchNoticePage(true)
  }, 400)
}

function applyKeywordSearch() {
  if (keywordDebounceTimer) {
    clearTimeout(keywordDebounceTimer)
    keywordDebounceTimer = null
  }
  if (!props.fetchFromApi || !isOpen.value) return
  resetListState()
  void fetchNoticePage(true)
}

function handleSearchClick() {
  resetListState()
  // 有实质查询条件（关键词或日期范围）时才标记为已搜索
  const hasRealFilter = !!String(filterKeyword.value || '').trim() ||
    (!!filterDateFrom.value && !!filterDateTo.value)
  hasSearched.value = hasRealFilter
  // 强制结束可能正在进行的加载，确保查询请求能发出去
  listLoading.value = false
  console.log('[handleSearchClick] 查询触发', { filterChangeType: filterChangeType.value, hasSearched: hasSearched.value })
  void fetchNoticePage(true)
}

// watch(filterKeyword, () => {
//   if (!props.fetchFromApi || !isOpen.value) return
//   scheduleKeywordFetch()
// })

// watch(filterChangeType, () => {
//   if (!props.fetchFromApi || !isOpen.value) return
//   resetListState()
//   void fetchNoticePage(true)
// })

watch(searchType, () => {
  if (!props.fetchFromApi || !isOpen.value) return
  resetListState()
  void fetchNoticePage(true)
})

onBeforeUnmount(() => {
  if (keywordDebounceTimer) clearTimeout(keywordDebounceTimer)
  document.removeEventListener('click', onDocumentClick)
})

// 根据文字获取对应的图片路径
const getProcessImage = (processName: string): string | undefined => {
  const process = processStatusOptions.find(item => item.title === processName)
  return process?.image
}

const displayItems = computed(() =>
  props.fetchFromApi ? internalItems.value : props.items
)

const canBatchExport = computed(() =>
  displayItems.value.some((it) => {
    const t = (it as Record<string, unknown>).changeType
    return t === 'QTY_UPDATE' || t === 'DRAW_UPDATE'
  })
)

/** 批量导出：需单日筛选且已点击查询 */
const showBatchExportButton = computed(() => isSingleDayDateFilter() && hasSearched.value)

const displayUnreadCount = computed(() => {
  if (typeof props.unreadCount === 'number') return props.unreadCount
  if (!props.fetchFromApi) return 0
  return internalUnreadCount.value
})

function joinSize(
  w?: string | number,
  d?: string | number,
  h?: string | number
): string | undefined {
  if (w == null && d == null && h == null) return undefined
  return [w, d, h].filter((x) => x !== '' && x != null).join('*')
}

function formatNoticeTime(dateStr: string | number | undefined): string | undefined {
  if (!dateStr) return '/'
  const date = new Date(dateStr)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  // const month = date.getMonth() + 1
  // const day = date.getDate()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${year}/${month}/${day} ${hours}:${minutes}`
}

function formatDateShow(dateStr: string | number | undefined): string | undefined {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  // const month = date.getMonth() + 1
  // const day = date.getDate()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${month}-${day}`
}

function formatDate(dateStr: string | number | undefined): string | undefined {
  if (!dateStr) return '/'
  const date = new Date(dateStr)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  // const month = date.getMonth() + 1
  // const day = date.getDate()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${year}/${month}/${day}`
}

const formatIntDate = (date: string | number | undefined) => {
  if (!date) return '/'
  const d = new Date(date)
  const year = d.getFullYear().toString().slice(-2)
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}/${parseInt(month)}/${parseInt(day)}`
}

/** 图纸字段常见格式：`payload` 为 JSON 字符串（如 ["https://..."]） */
function parseCoverFromImageUrls(imageUrls: unknown): string | undefined {
  if (imageUrls == null || imageUrls === '') return undefined
  if (typeof imageUrls === 'string') {
    const s = imageUrls.trim()
    if (!s) return undefined
    if (s.startsWith('[') || s.startsWith('{')) {
      try {
        const parsed = JSON.parse(s) as unknown
        if (Array.isArray(parsed) && parsed.length > 0) {
          const first = parsed[0]
          if (typeof first === 'string' && first.trim()) return first
          const firstObj = first as Record<string, unknown>
          if (typeof firstObj?.url === 'string') return firstObj.url
        }
      } catch {
        /* 非 JSON 则忽略 */
      }
    } else if (s.startsWith('http')) {
      return s
    }
    return undefined
  }
  if (Array.isArray(imageUrls) && imageUrls.length > 0) {
    const first = imageUrls[0]
    if (typeof first === 'string' && first.trim()) return first
    const firstObj = first as Record<string, unknown>
    return typeof firstObj?.url === 'string' ? firstObj.url : undefined
  }
  return undefined
}

function parseImageListFromImageUrls(imageUrls: unknown): Array<{ url: string; name?: string }> {
  if (imageUrls == null || imageUrls === '') return []
  if (typeof imageUrls === 'string') {
    const s = imageUrls.trim()
    if (!s) return []
    if (s.startsWith('[') || s.startsWith('{')) {
      try {
        const parsed = JSON.parse(s) as unknown
        if (Array.isArray(parsed)) {
          return parsed
            .map((x) => {
              if (typeof x === 'string') return { url: x }
              const r = x as Record<string, unknown>
              return { url: String(r?.url || ''), name: typeof r?.name === 'string' ? r.name : undefined }
            })
            .filter((x) => !!String(x.url).trim())
        }
      } catch {
        return []
      }
      return []
    }
    if (s.startsWith('http')) return [{ url: s }]
    return []
  }
  if (Array.isArray(imageUrls)) {
    return imageUrls
      .map((x) => {
        if (typeof x === 'string') return { url: x }
        const r = x as Record<string, unknown>
        return { url: String(r?.url || ''), name: typeof r?.name === 'string' ? r.name : undefined }
      })
      .filter((x) => !!String(x.url).trim())
  }
  return []
}

const CHANGE_TYPE_LABEL: Record<string, string> = {
  QTY_UPDATE: '数量变更'
}

function tagFromChangeType(changeType: unknown, fallback: string): string {
  if (typeof changeType !== 'string' || !changeType) return fallback
  return CHANGE_TYPE_LABEL[changeType] ?? changeType
}

/** 单条记录上直接带楼栋/楼层/房型与 old/newQuantity（无 areaList 时） */
function buildChangesFromFlatRow(
  raw: Record<string, unknown>
): LeftAlertChangeRow[] | undefined {
  const nested = normalizeChanges(
    raw.areaList ?? raw.changes ?? raw.area ?? raw.details
  )
  if (nested?.length) return nested

  const oldQ = raw.oldQuantity
  const newQ = raw.newQuantity
  if (oldQ == null && newQ == null) return undefined

  const parts = [
    raw.building,
    raw.floor,
    raw.areaRoomType,
    raw.roomNumber
  ].filter((x) => x !== '' && x != null)
  const name = parts.length ? parts.join('/') : '区域'

  return [
    {
      name,
      before:
        (oldQ as string | number) ??
        (raw.quantity as string | number) ??
        '—',
      after: (newQ as string | number) ?? '—'
    }
  ]
}

function normalizeChanges(raw: unknown): LeftAlertChangeRow[] | undefined {
  if (!Array.isArray(raw) || raw.length === 0) return undefined
  return raw.map((row: Record<string, unknown>) => {
    const parts = [
      row.building,
      row.floor,
      row.areaRoomType,
      row.roomNumber
    ].filter((x) => x !== '' && x != null)
    const name =
      (row.name as string) ||
      (row.areaName as string) ||
      (parts.length ? parts.join('/') : '—')
    return {
      name,
      before:
        (row.before as string | number) ??
        (row.quantity as string | number) ??
        (row.oldQuantity as string | number) ??
        '—',
      after:
        (row.after as string | number) ??
        (row.newQuantity as string | number) ??
        '—'
    }
  })
}

function extractListPayload(data: unknown): {
  rows: Record<string, unknown>[]
  total?: number
  unread?: number
  countItems?: Array<{ changeType?: string; count?: number | string }>
} {
  if (data == null) return { rows: [] }
  if (Array.isArray(data)) return { rows: data as Record<string, unknown>[] }
  const d = data as Record<string, unknown>
  const rows = (d.list ??
    d.records ??
    d.rows ??
    d.items ??
    []) as Record<string, unknown>[]
  const total = (d.total ?? d.totalCount ?? d.count) as number | undefined
  const unread = (d.unreadCount ?? d.unread ?? d.unreadTotal) as
    | number
    | undefined
  const rawCount = d.countItems
  const countItemsParsed = Array.isArray(rawCount)
    ? (rawCount as Array<{ changeType?: string; count?: number | string }>)
    : undefined
  return { rows, total, unread, countItems: countItemsParsed }
}

function applyUnreadFromItems(rows: LeftAlertCardItem[]) {
  const withRead = rows.filter((x) => 'read' in x && x.read === false)
  if (withRead.length) {
    internalUnreadCount.value = withRead.length
    return
  }
  const anyRead = rows.some((x) => 'read' in x)
  if (!anyRead && rows.length) {
    internalUnreadCount.value = rows.length
  }
}

async function fetchNoticePage(reset: boolean) {
  if (!props.fetchFromApi) return
  if (!reset) {
    if (listLoadingMore.value || !hasMore.value) return
  }

  const requestId = ++currentListRequestId
  const targetPage = reset ? 1 : listPage.value
  if (reset) {
    listLoading.value = true
    listError.value = ''
  } else {
    listLoadingMore.value = true
  }

  try {
    const res = (await urgentNoticeApi.getUrgentNoticeList(
      buildNoticeListParams(targetPage)
    )) as { code?: number; msg?: string; message?: string; data?: unknown }

    // 如果已经有更新的请求发出，丢弃本次结果
    if (requestId !== currentListRequestId) return

    if (res.code !== 0) {
      listError.value = res.msg || res.message || '加载失败'
      if (reset) {
        internalItems.value = []
        countItems.value = []
      }
      console.log('[fetchNoticePage] 接口返回错误', res.msg || res.message)
      return
    }

    const { rows, total, unread, countItems: payloadCountItems } = extractListPayload(res.data)
    const mapped = rows

    if (reset) {
      // 首次打开并成功拉取列表后，清除服务端红点
      void urgentNoticeApi
        .confirm()
        .then((confirmRes: { code?: number }) => {
          if (confirmRes?.code === 0) {
            internalUnreadCount.value = 0
            emit('refresh-unread')
          }
        })
        .catch(() => {})
      internalItems.value = mapped
      listPage.value = 2
      if (Array.isArray(payloadCountItems)) {
        countItems.value = payloadCountItems
      } else {
        countItems.value = []
      }
      if (typeof unread === 'number') {
        internalUnreadCount.value = unread
      } else {
        applyUnreadFromItems(mapped)
      }
    } else {
      internalItems.value = [...internalItems.value, ...mapped]
      listPage.value = targetPage + 1
    }

    if (typeof total === 'number') {
      hasMore.value = internalItems.value.length < total
    } else {
      hasMore.value = mapped.length >= getNoticeListPageSize()
    }
  } catch (e: unknown) {
    const msg = e instanceof Error ? e.message : '网络异常'
    listError.value = msg
    if (reset) {
      internalItems.value = []
      countItems.value = []
    }
    console.log('[fetchNoticePage] 请求异常', msg)
  } finally {
    listLoading.value = false
    listLoadingMore.value = false
    if (reset) {
      initialListLoaded.value = true
    }
  }
}

function resetListState() {
  listPage.value = 1
  hasMore.value = true
  listError.value = ''
  internalItems.value = []
  hasSearched.value = false
}

let scrollTick = false
/** 当前正在进行的列表请求 ID，用于防止旧请求覆盖新请求 */
let currentListRequestId = 0

function onScroll() {
  if (!props.fetchFromApi || !isOpen.value) return
  if (scrollTick) return
  scrollTick = true
  requestAnimationFrame(() => {
    scrollTick = false
    const el = scrollRef.value
    if (!el || listLoading.value || listLoadingMore.value || !hasMore.value)
      return
    const threshold = 72
    if (el.scrollHeight - el.scrollTop - el.clientHeight < threshold) {
      void fetchNoticePage(false)
    }
  })
}

const currentStatusImage = computed(() => {
  if (isOpen.value) return openStatusImg
  if (displayUnreadCount.value > 0) return closeStatusUnreadImg
  if (displayUnreadCount.value === 0) return closeStatusReadImg
  return closeStatusReadImg
})

const toggleOpen = () => {
  isOpen.value = !isOpen.value
  emit('toggle', isOpen.value)
  if (isOpen.value) {
    emit('open')
    return
  }
  emit('close')
}

function onDocumentClick(e: MouseEvent) {
  if (!isOpen.value || !containerRef.value) return
  const target = e.target as Node
  if (!containerRef.value.contains(target)) {
    // 排除 Vuetify overlay/下拉菜单的点击，避免选择 v-select 时误关闭面板
    const overlay = (target as HTMLElement)?.closest?.('.v-overlay__content, .v-overlay, .v-menu')
    if (overlay) return
    isOpen.value = false
    emit('toggle', false)
    emit('close')
  }
}

watch(isOpen, (open) => {
  if (open && props.fetchFromApi && props.visible) {
    resetListState()
    void fetchNoticePage(true)
  }
  if (open) {
    setTimeout(() => {
      document.addEventListener('click', onDocumentClick)
    }, 0)
  } else {
    document.removeEventListener('click', onDocumentClick)
  }
})

watch(
  () => props.visible,
  (val) => {
    if (!val) {
      isOpen.value = false
    }
  }
)

// // 导出新图纸
// const handleExportNewDraw = async (item: Record<string, unknown>) => {
//   if (exportingNewDraw.value || exportingChangeOrder.value) return
//   exportingNewDraw.value = true
//   try {
//     const imageList = parseImageListFromImageUrls(item?.payload ?? item?.imageUrls)
//     if (imageList.length === 0) {
//       throw new Error('未找到可导出的图纸')
//     }

//     const pdf = new jsPDF('landscape', 'mm', 'a4')
//     const pageWidth = pdf.internal.pageSize.getWidth()
//     const pageHeight = pdf.internal.pageSize.getHeight()
//     const margin = 6
//     let hasAddedPage = false

//     for (const img of imageList) {
//       const dataUrl = await convertImageToDataUrl(img.url)
//       if (!dataUrl || !dataUrl.startsWith('data:image')) {
//         continue
//       }

//       const imageElement = await new Promise<HTMLImageElement>((resolve, reject) => {
//         const el = new Image()
//         el.onload = () => resolve(el)
//         el.onerror = () => reject(new Error('图片加载失败'))
//         el.src = dataUrl
//       })

//       const maxWidth = pageWidth - margin * 2
//       const maxHeight = pageHeight - margin * 2
//       const widthRatio = maxWidth / imageElement.width
//       const heightRatio = maxHeight / imageElement.height
//       const scale = Math.min(widthRatio, heightRatio)
//       const renderWidth = imageElement.width * scale
//       const renderHeight = imageElement.height * scale
//       const x = (pageWidth - renderWidth) / 2
//       const y = (pageHeight - renderHeight) / 2

//       if (hasAddedPage) {
//         pdf.addPage()
//       }
//       pdf.addImage(dataUrl, 'PNG', x, y, renderWidth, renderHeight)
//       hasAddedPage = true
//     }

//     if (!hasAddedPage) {
//       throw new Error('图纸图片加载失败，无法导出')
//     }

//     const contractCode = String(item?.contractCode || '未知合同')
//     const productCode = String(item?.productCode || '')
//     const fileName = productCode ? `新图纸_${contractCode}_${productCode}.pdf` : `新图纸_${contractCode}.pdf`
//     pdf.save(fileName)
//     showSuccess('导出新图纸成功')
//   } catch (error) {
//     console.error('导出新图纸失败:', error)
//   } finally {
//     exportingNewDraw.value = false
//   }
// }

// 导出新图纸
const handleExportNewDraw = async (
  item: Record<string, unknown>,
  opts?: { quiet?: boolean; fromBatch?: boolean }
) => {
  if (exportingBatch.value && !opts?.fromBatch) return
  if (!opts?.fromBatch && (exportingNewDraw.value || exportingChangeOrder.value)) return
  exportingNewDraw.value = true
  try {
    const imageList = parseImageListFromImageUrls(item?.payload ?? item?.imageUrls)
    if (imageList.length === 0) {
      throw new Error('未找到可导出的图纸')
    }

    currentDrawCoverItem.value = { ...(item || {}) }
    await nextTick()
    await sleep(220)
    const coverEl = document.getElementById('draw-change-cover-pdf-content')
    if (!coverEl) {
      throw new Error('未找到图纸变更封面预览')
    }
    await waitForImagesReady(coverEl, 10000)
    await sleep(120)
    const coverCanvas = await html2canvas(coverEl, {
      scale: PDF_QUALITY,
      useCORS: true,
      imageTimeout: 15000,
      foreignObjectRendering: false,
      logging: false,
      backgroundColor: '#ffffff',
      width: coverEl.scrollWidth,
      height: coverEl.scrollHeight
    })

    const pdf = new jsPDF('portrait', 'mm', 'a4')
    {
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()
      const imgWidth = pageWidth
      const imgHeight = (coverCanvas.height * pageWidth) / coverCanvas.width
      const imgData = coverCanvas.toDataURL('image/jpeg', PDF_QUALITY)
      const PAGE_EPSILON = 1
      if (imgHeight <= pageHeight + PAGE_EPSILON) {
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, Math.min(imgHeight, pageHeight))
      } else {
        let heightLeft = imgHeight
        let position = 0
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
        heightLeft -= pageHeight
        while (heightLeft > PAGE_EPSILON) {
          position = heightLeft - imgHeight
          pdf.addPage()
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
          heightLeft -= pageHeight
        }
      }
    }

    const margin = 6
    let hasAddedDrawPage = false

    for (const img of imageList) {
      const dataUrl = await convertImageToDataUrl(img.url)
      if (!dataUrl || !dataUrl.startsWith('data:image')) {
        continue
      }
      const rotatedDataUrl = await rotateImageDataUrl(dataUrl, 90)
      if (!rotatedDataUrl) {
        continue
      }

      const imageElement = await new Promise<HTMLImageElement>((resolve, reject) => {
        const el = new Image()
        el.onload = () => resolve(el)
        el.onerror = () => reject(new Error('图片加载失败'))
        el.src = rotatedDataUrl
      })

      pdf.addPage('a4', 'p')
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()
      const maxWidth = pageWidth - margin * 2
      const maxHeight = pageHeight - margin * 2
      const widthRatio = maxWidth / imageElement.width
      const heightRatio = maxHeight / imageElement.height
      const scale = Math.min(widthRatio, heightRatio)
      const renderWidth = imageElement.width * scale
      const renderHeight = imageElement.height * scale
      const x = (pageWidth - renderWidth) / 2
      const y = (pageHeight - renderHeight) / 2

      pdf.addImage(rotatedDataUrl, 'PNG', x, y, renderWidth, renderHeight)
      hasAddedDrawPage = true
    }

    if (!hasAddedDrawPage) {
      throw new Error('图纸图片加载失败，无法导出')
    }

    const contractCode = String(item?.contractCode || '未知合同')
    const productCode = String(item?.productCode || '')
    const fileName = productCode ? `新图纸_${contractCode}_${productCode}.pdf` : `新图纸_${contractCode}.pdf`
    pdf.save(fileName)
    const updateRes = await urgentNoticeApi.updateOperationTime({ noticeIds: [item.id] }) as { data?: { exportTime?: string } }
    item.operationTime = updateRes?.data?.exportTime || new Date()
    item.isShowLog = true
    if (!opts?.quiet) {
      showSuccess('导出新图纸成功')
    }
  } catch (error) {
    console.error('导出新图纸失败:', error)
  } finally {
    exportingNewDraw.value = false
  }
}

// 导出变更单
async function handleExportChangeOrder(
  item: Record<string, unknown>,
  opts?: { fromBatch?: boolean }
) {
  if (exportingBatch.value && !opts?.fromBatch) return
  if (!opts?.fromBatch && (exportingNewDraw.value || exportingChangeOrder.value)) return
  exportingChangeOrder.value = true
  const rawCover =
    (item?.cover as string | undefined) ||
    parseCoverFromImageUrls((item as Record<string, unknown>)?.imageUrls) ||
    ''
  const exportCover = await convertImageToDataUrl(rawCover)
  currentChangeOrderOriginalItem.value = item
  currentChangeOrderItem.value = {
    ...(item || {}),
    cover: exportCover || rawCover
  }
  await nextTick()
  await sleep(220)
  await handleConfirmExportChangeOrder()
}

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result || ''))
    reader.onerror = () => reject(new Error('blob转base64失败'))
    reader.readAsDataURL(blob)
  })
}

async function convertImageToDataUrl(url: string): Promise<string> {
  if (!url) return ''
  if (url.startsWith('data:')) return url
  try {
    const res = await fetch(url, { mode: 'cors', cache: 'no-store' })
    if (res.ok) {
      const blob = await res.blob()
      return await blobToDataUrl(blob)
    }
  } catch {
    // ignore and fallback
  }
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image()
      el.crossOrigin = 'anonymous'
      el.onload = () => resolve(el)
      el.onerror = () => reject(new Error('图片加载失败'))
      el.src = url
    })
    const canvas = document.createElement('canvas')
    canvas.width = img.naturalWidth || img.width
    canvas.height = img.naturalHeight || img.height
    const ctx = canvas.getContext('2d')
    if (!ctx) return url
    ctx.drawImage(img, 0, 0)
    return canvas.toDataURL('image/jpeg', PDF_QUALITY)
  } catch {
    return url
  }
}

async function rotateImageDataUrl(dataUrl: string, angle: 90 | 270 = 90): Promise<string> {
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image()
      el.onload = () => resolve(el)
      el.onerror = () => reject(new Error('图片旋转前加载失败'))
      el.src = dataUrl
    })
    const width = img.naturalWidth || img.width
    const height = img.naturalHeight || img.height
    if (!width || !height) return ''

    const canvas = document.createElement('canvas')
    canvas.width = height
    canvas.height = width
    const ctx = canvas.getContext('2d')
    if (!ctx) return ''

    if (angle === 90) {
      ctx.translate(canvas.width, 0)
      ctx.rotate(Math.PI / 2)
    } else {
      ctx.translate(0, canvas.height)
      ctx.rotate(-Math.PI / 2)
    }
    ctx.drawImage(img, 0, 0, width, height)
    return canvas.toDataURL('image/jpeg', PDF_QUALITY)
  } catch {
    return ''
  }
}

async function waitForImagesReady(container: HTMLElement, timeoutMs = 8000) {
  const imageEls = Array.from(container.querySelectorAll('img')) as HTMLImageElement[]
  if (imageEls.length === 0) return
  const tasks = imageEls.map((img) => {
    if (img.complete) return Promise.resolve()
    return new Promise<void>((resolve) => {
      const done = () => resolve()
      img.addEventListener('load', done, { once: true })
      img.addEventListener('error', done, { once: true })
    })
  })
  await Promise.race([Promise.all(tasks), sleep(timeoutMs)])
}

async function handleConfirmExportChangeOrder() {
  try {
    await nextTick()
    const pageElement = document.getElementById('change-order-pdf-content')
    if (!pageElement) {
      throw new Error('未找到变更单预览内容')
    }
    await waitForImagesReady(pageElement, 10000)
    await sleep(120)
    const canvas = await html2canvas(pageElement, {
      scale: PDF_QUALITY,
      useCORS: true,
      imageTimeout: 15000,
      foreignObjectRendering: false,
      logging: false,
      backgroundColor: '#ffffff',
      width: pageElement.scrollWidth,
      height: pageElement.scrollHeight
    })
    const pdf = new jsPDF('portrait', 'mm', 'a4')
    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = pdf.internal.pageSize.getHeight()
    const imgWidth = pageWidth
    const imgHeight = (canvas.height * pageWidth) / canvas.width
    const imgData = canvas.toDataURL('image/jpeg', PDF_QUALITY)

    const PAGE_EPSILON = 1
    if (imgHeight <= pageHeight + PAGE_EPSILON) {
      // 接近一页时按一页导出，避免浮点误差导致空白第二页
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, Math.min(imgHeight, pageHeight))
    } else {
      // 超过一页时拆分页，避免内容被截断
      let heightLeft = imgHeight
      let position = 0
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
      heightLeft -= pageHeight
      while (heightLeft > PAGE_EPSILON) {
        position = heightLeft - imgHeight
        pdf.addPage()
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
        heightLeft -= pageHeight
      }
    }

    const contractCode = String(currentChangeOrderItem.value.contractCode || '未知合同')
    const fileName = `变更单_${contractCode}.pdf`
    pdf.save(fileName)
    const updateRes = await urgentNoticeApi.updateOperationTime({ noticeIds: [currentChangeOrderItem.value.id] }) as { data?: { exportTime?: string } }
    const opTime = updateRes?.data?.exportTime || new Date()
    currentChangeOrderItem.value.operationTime = opTime
    currentChangeOrderItem.value.isShowLog = true
    if (currentChangeOrderOriginalItem.value) {
      currentChangeOrderOriginalItem.value.operationTime = opTime
      currentChangeOrderOriginalItem.value.isShowLog = true
    }
  } catch (error) {
    console.error('导出变更单失败:', error)
  } finally {
    exportingChangeOrder.value = false
  }
}

async function exportAllItems() {
  if (exportingBatch.value) return
  const targets = displayItems.value.filter((it) => {
    const t = (it as Record<string, unknown>).changeType
    return t === 'QTY_UPDATE' || t === 'DRAW_UPDATE'
  }) as Record<string, unknown>[]
  if (!targets.length) {
    showError('当前列表中没有可导出的变更单')
    return
  }
  exportingBatch.value = true
  try {
    for (const raw of targets) {
      if (raw.changeType === 'QTY_UPDATE') {
        await handleExportChangeOrder(raw, { fromBatch: true })
      } else if (raw.changeType === 'DRAW_UPDATE') {
        await handleExportNewDraw(raw, { quiet: true, fromBatch: true })
      }
      await sleep(350)
    }
    showSuccess(`已批量导出 ${targets.length} 个变更单`)
  } catch (e) {
    console.error(e)
    showError('批量导出过程中出现错误')
  } finally {
    exportingBatch.value = false
    exportingChangeOrder.value = false
    exportingNewDraw.value = false
  }
}

const handleViewExportRecord = (item: Record<string, unknown>) => {
  // router.push({
  //   name: 'export-record',
  //   query: {
  //     noticeId: String(item.id ?? '')
  //   }
  // })
  const url = `/export-record?noticeId=${String(item.id ?? '')}`
  window.open(url, '_blank')
}

const handleViewNewDraw = (item: Record<string, unknown>) => {
  const drawUrls = parseImageListFromImageUrls(item?.payload ?? item?.imageUrls)
  if (!drawUrls.length) {
    showError('暂无图纸')
    return
  }
  window.open(drawUrls[0].url, '_blank')
}

const doAudit = async (item: Record<string, unknown>, auditStatus: number) => {
  try {
    const res = (await urgentNoticeApi.audit({
      id: item.id,
      auditStatus,
    })) as { code?: number; message?: string; msg?: string }
    if (res.code === 0) {
      showSuccess(auditStatus === 1 ? '审核通过' : '已驳回')
      item.auditStatus = auditStatus
    } else {
      showError(res.message || res.msg || '操作失败')
    }
  } catch {
    showError('操作失败')
  }
}

const handleReject = (item: Record<string, unknown>) => {
  if (!confirm('确定要驳回该申请吗？')) return
  void doAudit(item, 2)
}

const handleApprove = (item: Record<string, unknown>) => {
  if (!confirm('确定要审核通过该申请吗？')) return
  void doAudit(item, 1)
}
</script>

<style scoped lang="scss">
.left-alert-container {
  position: fixed;
  left: 0;
  top: 100px;
  z-index: 1001;
  display: flex;
  align-items: flex-start;
}

.left-alert-btn {
  width: 32px;
  height: auto;
  // height: 120px;
  cursor: pointer;
  user-select: none;
}

.left-alert-content {
  width: 360px;
  height: 80vh;
  margin-left: 10px;
  padding: 12px 14px 14px;
  background: #08090d;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 20px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.4);
  color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.left-alert-toolbar {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.left-alert-field :deep(.v-field) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.left-alert-field :deep(.v-field__input) {
  color: rgba(255, 255, 255, 0.92) !important;
  font-size: 13px;
}

.left-alert-field :deep(.v-label) {
  color: rgba(255, 255, 255, 0.65) !important;
  font-size: 12px;
}

.left-alert-field :deep(.v-field__outline) {
  --v-field-border-opacity: 0.22;
}

.left-alert-field :deep(.v-icon) {
  color: rgba(255, 255, 255, 0.55) !important;
}

.left-alert-search :deep(input::placeholder) {
  color: rgba(255, 255, 255, 0.45) !important;
}

.left-alert-date-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.left-alert-date-row .native-date-wrapper {
  position: relative;
  flex: 1;
  min-width: 0;
}

.native-date-field {
  cursor: pointer;
}

.left-alert-date-sep {
  flex-shrink: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.left-alert-date-actions {
  display: flex;
  justify-content: flex-end;
}

.left-alert-link-btn {
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  color: #eb6d86;
  cursor: pointer;
  text-decoration: underline;
}

.left-alert-link-btn:hover {
  color: #f090a3;
}

.left-alert-count-summary {
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.left-alert-count-box {
  flex: 1;
  min-width: 0;
  padding: 10px 10px 8px;
  border-radius: 8px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
}

.left-alert-count-box--muted {
  opacity: 0.55;
}

.left-alert-count-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.left-alert-count-title {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  border-left: 3px solid #e24c65;
  line-height: 1.2;
  padding-left: 6px;
}

.left-alert-count-box--muted .left-alert-count-title {
  color: #898989;
  border-left: none;
  padding-left: 0;
}

.left-alert-count-label {
  font-size: 11px;
  color: #adadad;
}

.left-alert-count-box--muted .left-alert-count-label {
  color: #898989;
}

.left-alert-count-bottom {
  text-align: right;
}

.left-alert-count-num {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  font-variant-numeric: tabular-nums;
}

.left-alert-count-num--muted {
  font-size: 18px;
  color: #898989;
}

.left-alert-count-box--muted .left-alert-count-num:not(.left-alert-count-num--muted) {
  color: #898989;
}

.left-alert-bar {
  flex-shrink: 0;
  font-size: 15px;
  font-weight: 600;
  padding: 6px 4px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 10px;
}

.left-alert-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 3px;
  }
}

/* —— 单张卡片（对齐 jf-client alertCard） —— */
.alert-card {
  background: #08090d;
  border-radius: 8px;
  padding: 12px 6px 14px;
  color: #fff;
  margin-bottom: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);

  &:last-child {
    margin-bottom: 4px;
  }
}

.top {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}

.top-border {
  width: 5px;
  flex-shrink: 0;
  background: #e24c65;
  border-radius: 5px;
  margin-right: 10px;
}

.top-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  gap: 8px;
}

.top-left {
  min-width: 0;
  flex: 1;
}

.time {
  color: #8f95a3;
  font-size: 12px;
  line-height: 1.3;
}

.card-title {
  font-size: 17px;
  font-weight: 600;
  word-break: break-word;
  width: 80%;
}

.order-no {
  color: #d9dde6;
  font-size: 13px;
}

.change-type-tag {
  flex-shrink: 0;
  align-self: flex-start;
  display: block;
  height: 20px;
  width: auto;
}

.goods {
  margin-top: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.cover-wrap {
  position: relative;
  width: 80px;
  height: 80px;
  flex-shrink: 0;
}

.cover-img,
.cover-placeholder {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  object-fit: cover;
  display: block;
}

.cover-placeholder {
  background: #3b3f46;
}

.job {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 1;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 11px;
  text-align: center;
  background: rgba(0, 0, 0, 0.54);
  color: #fff;
}

.meta {
  flex: 1;
  min-width: 0;
}

.meta-row {
  color: #848485;
  font-size: 13px;
  line-height: 1.65;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px;
}

.meta-label {
  color: #fff;
  flex-shrink: 0;
}

.meta-value {
  color: #848485;
  word-break: break-all;
}

.change-info{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
}

.change-head,
.change-row {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 12px;
  font-size: 13px;
  text-align: left;
  align-items: center;
}

.change-head {
  color: #c1c6d2;
  padding: 0 2px;
}

.change-row {
  padding: 10px 8px;
  background: rgba(255, 255, 255, 0.059);
  border-radius: 4px;
}

.area-name {
  color: #d7dce7;
  min-width: 0;
  word-break: break-all;
}

.count {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 10px;
}

.count-val {
  color: #eb6d86;
  font-size: 13px;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}

.count-arrow {
  width: 10px;
  height: auto;
  flex-shrink: 0;
  display: block;
}

.change-empty {
  margin-top: 10px;
  font-size: 12px;
  color: #8f95a3;
  padding: 8px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 4px;
}

/* 兼容纯文本 */
.legacy-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.legacy-item {
  font-size: 14px;
  line-height: 1.5;
  padding: 12px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.88);
}

.left-alert-empty {
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
}

.list-footer {
  padding: 12px 4px 8px;
  text-align: center;
}

.footer-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
}

.footer-text.muted {
  color: rgba(255, 255, 255, 0.38);
}

.factory {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 30px;
  height: 18px;
  z-index: 99;
}

.actions-btns .action-btn {
  min-width: 52px !important;
  height: 28px !important;
  line-height: 24px !important;
  font-size: 12px !important;
  padding: 0 4px !important;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #FFFFFF;
  cursor: pointer;
}

.change-order-export-host {
  position: fixed;
  left: 0;
  top: 0;
  pointer-events: none;
  z-index: -1;
}

.common-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.common-loading-container {
  text-align: center;
  color: #fff;
}

.common-loading-spinner {
  border: 4px solid #2B2D33;
  border-top: 4px solid #D2475D;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.common-loading-text {
  margin-top: 16px;
  font-size: 14px;
  margin-bottom: 0;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* —— 图纸变更详情（对齐 panelMy） —— */
.change-detail-panel {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.change-detail-row {
  display: flex;
  // align-items: center;
  font-size: 13px;
  line-height: 1.8;
}

.change-detail-label {
  color: #8f95a3;
  margin-right: 8px;
  flex-shrink: 0;
}

.change-detail-value {
  color: #ffffff;
}

.change-detail-value.reason {
  flex: 1;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
}

/* —— 工序统计 —— */
.process-stats {
  margin-top: 10px;
}

.process-header {
  display: flex;
  align-items: center;
  padding: 8px;
  background: #161617;
}

.process-header .ph-cell {
  flex: 1;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
}

.process-header .ph-cell:first-child {
  text-align: left;
  flex: 0 0 70px;
}

.process-row {
  display: flex;
  align-items: center;
  padding: 8px;
  background: #161617;
  margin-top: 3px;
}

.process-row .p-cell {
  flex: 1;
  text-align: center;
  font-size: 13px;
  color: #ffffff;
}

.process-row .p-cell:first-child {
  text-align: left;
  flex: 0 0 70px;
}

.tag-cell {
  display: flex;
  align-items: center;
}

.process-design-tag,
.process-name-tag {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

/* —— 操作按钮与状态 —— */
.card-actions {
  margin-top: 12px;
  display: flex;
  gap: 10px;
}

.card-actions .action-btn {
  flex: 1;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
}

.btn-reject {
  background: #444852;
  color: #ffffff;
}

.btn-approve {
  background: #e24c65;
  color: #ffffff;
}

.status-bar {
  margin-top: 10px;
}

.status-tag {
  height: 32px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  border-radius: 4px;
}

.status-wait {
  background-color: #453f2e;
  color: #eab20b;
}

.status-approved {
  background-color: #3b4d3e;
  color: #66bb6a;
}

.status-rejected {
  background: #3d2a2a;
  color: #e24c65;
}

.search-type-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin-top: 14px;
  .button-group {
    border-radius: 24px;
    background-color: #333;
    overflow: hidden;
    height: 32px;
  }

  .toggle-button {
    min-width: 42px;
    border-radius: 24px;
    font-weight: 500;
    color: #999 !important;

    &.v-btn--active {
      background: var(--primary-gradient) !important;
      color: white !important;
    }
  }
}

.stats {
  margin-top: 20px;
  display: flex;
  gap: 16px;
}

.stat-item {
  flex: 1;
  min-width: 0;
  padding: 10px 10px 8px;
  border-radius: 8px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stat-label {
  font-size: 13px;
  color: #8f95a3;
  line-height: 1;
  border-left: 2px solid #e24c65;
  padding-left: 4px;
  margin-bottom: 4px;
}

.stat-value {
  // margin-top: 8px;
  font-size: 16px;
  color: #ffffff;
  font-weight: 500;
  line-height: 1.4;
}

.log-btn{
  padding: 1px;
  cursor: pointer;
  // margin-left: 5px;
  border: 1px solid #FFFFFF;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  box-sizing: border-box;
  position: relative;
  margin-left: 4px;
}

.batch-tt-header {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  padding: 8px 14px;
  border-bottom: 1px solid #33363d;
  font-size: 11px;
  color: #898989;
  font-weight: 400;
  min-width: 200px;
}

.batch-tt-row {
  // display: grid;
  // grid-template-columns: 1fr 1fr;
  width: 100%;
  column-gap: 16px;
  padding: 7px 14px;
  border-bottom: 1px solid #2a2a2e;
  font-size: 12px;
  color: #ccc;
  align-items: center;
}

.batch-tt-row:last-child {
  border-bottom: none;
}

.batch-tooltip {
  max-width: 360px;
}

.batch-comma-list {
  word-break: break-word;
  line-height: 1.6;
}
</style>
